<template>
  <v-dialog v-model="internal">
    <v-card> 
      <!-- v-tool bar title-->
      <v-toolbar dense flat class="mb-4 sticky-toolbar">
        <v-toolbar-title>
          {{ marketData.title }}
        </v-toolbar-title>

    <v-spacer></v-spacer>
          <v-btn icon @click="internal = false">
            <v-icon>{{ "mdi-close" }}</v-icon>
          </v-btn>

      </v-toolbar >

      <!--content-->
      <v-card-text>
        <component v-if="marketData.component" :is="marketData.component" v-bind="marketData.content" />
        <slot v-else></slot>
      </v-card-text>
    </v-card>
  </v-dialog>
</template>
<script>
import { useSettingsStore } from '@/store';
export default {
  name: "MarketModal",
  props: {
    value: { type: Boolean, default: false },
    marketData: {
      type: Object,
      default: () => ({ title: "", component: null, content: {} }),
      title: [String, Object],
      content: { type: Object },
    },
  },
  computed: {
    internal: {
      get() {
        return this.value;
      },
      set(v) {
        const settingsStore = useSettingsStore()
        settingsStore.isModalOn = false;
        this.$emit("input", v);
      },
    },
  },
};
</script>

<style scoped>
.sticky-toolbar{
  position:sticky;
  top:0;
  z-index: 10;
}
</style>